import BuildingType from '@/roc/building/BuildingType';
import BuildingMaxLevel from '@/roc/building/BuildingMaxLevel';
import Effects from '@/roc/effects/Effects';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';
import {BuildingFlags} from '@/roc/building/BuildingTemplate';

const LuxuriousCultureSite = {
  id: '22',
  name: 'Luxurious Culture Site',
  width: 3,
  height: 2,
  type: BuildingType.CULTURE,
  era: 'stoneAge',
  icon: 'Culture_Range',
  minLevel: 1,
  maxLevel: BuildingMaxLevel.ONE_OFF,
  url: 'https://riseofcultures.wiki.gg/wiki/Home_Cultures/Culture_Sites/Luxurious_Culture_Site',
  flags: BuildingFlags.LUXURIOUS,
  counts: {
    stoneAge: 1,
    bronzeAge: 2,
    minoanEra: 3,
    classicGreece: 4,
    earlyRome: 5,
    romanEmpire: 6,
    byzantineEra: 7,
    ageOfTheFranks: 7,
    feudalAge: 7,
    iberianEra: 7,
    kingdomOfSicily: 8,
    highMiddleAges: 8,
    earlyGothicEra: 8,
    lateGothicEra: 8,
  },
  effects: Effects.create([
    new CultureBonus(
      CultureAmount.asPerLevel([360, 420, 480, 600, 720, 840, 1020, 1200, 1440, 1740, 2100, 2520, 2800, 3080]),
      CultureRange.asFlat(2),
    ),
  ]),
};

export default LuxuriousCultureSite;
